export const VENUE_CONFIG = {
  facilities: {
    performance: [
      {
        name: "Concert Hall",
        description: "300-seat performance hall with customizable acoustics",
        type: "primary"
      },
      {
        name: "Recital Hall",
        description: "Intimate performance space with excellent acoustics",
        type: "secondary"
      }
    ],
    practice: {
      description: "Multiple practice rooms with quality pianos",
      availability: "Extended hours access"
    },
    amenities: {
      athletic: {
        description: "Modern athletic and recreation facilities",
        features: [
          "Fitness facilities",
          "Recreational spaces",
          "Outdoor areas"
        ]
      },
      dining: {
        description: "Full-service dining facilities",
        features: [
          "Three meals daily",
          "Diverse menu options",
          "Dietary accommodations",
          "Extended hours"
        ]
      },
      housing: {
        description: "Modern residence facilities",
        features: [
          "Air-conditioned rooms",
          "Common spaces",
          "Laundry facilities",
          "WiFi access"
        ]
      }
    }
  },
  transportation: {
    shuttle: "Festival shuttle service for select events",
    public: "Local public transportation available"
  }
} as const;